import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRatewareCalcUomCodeLookup extends Layout {
    sourceCalcUomCode: DataSource;
    tableCalcUomCode: Table;
}
